import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-no-selected-chat',
  imports: [],
  templateUrl: './no-selected-chat.component.html',
  styleUrl: './no-selected-chat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoSelectedChatComponent {}
